import React from "react";

import CGMSelectConnectionMethodBottomSheet from "src/components/app/bottom-sheet/cgm/CGMSelectConnectionMethodBottomSheet";
import CGMWarningBottomSheet from "src/components/app/bottom-sheet/cgm/CGMWarningBottomSheet";
import CGMGuideBottomSheet from "src/components/app/bottom-sheet/cgm/CGMGuideBottomSheet";
import CGMIntroStatusCard from "./CGMStatusCard/CGMIntroStatusCard";
import CGMConnectionGuide from "../connection/CGMConnectionGuide";
import CGMConnectVideoTutorials from "../connection/CGMConnectVideoTutorials";
import Layout from "../../layout/Layout";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../layout/Header";
import { Headphones } from "@material-symbols-svg/react";

type VideoTutorial = {
  title: string;
  description: string;
  url: string;
};

type IntroStepProps = {
  showMethodSheet: boolean;
  setShowMethodSheet: (show: boolean) => void;
  showWarningSheet: boolean;
  setShowWarningSheet: (show: boolean) => void;
  showGuideSheet: boolean;
  setShowGuideSheet: (show: boolean) => void;

  onSelectSelfInstallation: () => void;
  onSelectVirtualInstallation: () => void;
  onProceedFromWarning: () => void;
  handleBack: () => void;
  onStartJourney: () => void;
};

const IntroStep: React.FC<IntroStepProps> = ({
  showMethodSheet,
  setShowMethodSheet,
  showWarningSheet,
  setShowWarningSheet,
  showGuideSheet,
  setShowGuideSheet,

  onSelectSelfInstallation,
  onSelectVirtualInstallation,
  onProceedFromWarning,
  handleBack,
  onStartJourney,
}) => {
  const params = useParams();
  const navigate = useNavigate();
  const supportProgramKey = params["support-program-key"] ?? "";

  return (
    <Layout
      supportProgramKey={supportProgramKey}
      className="bg-white"
      containerClassName="bg-white"
      header={
        <Header
          title="Back"
          onBackClick={handleBack}
          rightComponent={
            <button
              className="mr-16 flex items-center gap-2 whitespace-nowrap font-semibold text-[var(--app-primary)]"
              onClick={() =>
                navigate(`/app/${supportProgramKey}/cgm-need-help`)
              }
            >
              <Headphones />
              Need Help?
            </button>
          }
        />
      }
    >
      <CGMIntroStatusCard onStartJourney={onStartJourney} />
      <CGMConnectionGuide />
      <CGMConnectVideoTutorials className="px-4" />

      <CGMSelectConnectionMethodBottomSheet
        show={showMethodSheet}
        onClose={() => setShowMethodSheet(false)}
        onSelectSelf={onSelectSelfInstallation}
        onSelectVirtual={onSelectVirtualInstallation}
      />
      <CGMWarningBottomSheet
        show={showWarningSheet}
        onClose={() => setShowWarningSheet(false)}
        onProceed={onProceedFromWarning}
        onBookConsultation={onSelectVirtualInstallation}
      />
      <CGMGuideBottomSheet
        show={showGuideSheet}
        onClose={() => setShowGuideSheet(false)}
      />
    </Layout>
  );
};

export default IntroStep;
